<template>
  <div class="DeepInfo flex flex-col h-screen bg-beige">
    <div class="logo-header-container ml-8 mt-8">
      <div class="logo-header flex">
        <div class="logo w-32">
          <img class="w-full" src="https://blissing.s3-us-west-1.amazonaws.com/img/blissing_UN_logo_icon_v02.png" alt="blissing blue image logo">
        </div>
        <div class="flex flex-col ml-4">
          <img class="blissing-logo" src="https://blissing.s3-us-west-1.amazonaws.com/img/BLISSING_BW.png" alt="blissing text logo">
          <span class="text-2xl text-left ml-1 font-bold border-4ads border-b-4 leading-none self-start mt-1">DEEP INFO FOR EXPERTS</span>
        </div>
      </div>
    </div>

    <div class="flex m-auto">
      <div @click="changeView('DeepInfoOffer')" class="circles flex rounded-full bg-purple mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-2xl leading-tight text-black">WHAT DOES <br> BLISSING <br> OFFER?</h4>
      </div>
      <div @click="changeView('DeepInfoGeneral')" class="circles flex rounded-full bg-turquoise mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-2xl leading-tight text-black">GENERAL <br> INFORMATION</h4>
      </div>
      <div @click="changeView('DeepInfoConcept')" class="circles flex rounded-full bg-yellow mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-2xl leading-tight text-black">CONCEPT <br> INFORMATION</h4>
      </div>
      <div @click="changeView('DeepInfoProcess')" class="circles flex rounded-full bg-orange cursor-pointer">
        <h4 class="font-bold m-auto text-center text-2xl leading-tight text-black">PROFIT &<br>PROCESS </h4>
      </div>
    </div>

    <Navigation textColor="black"/>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";

export default {
  name: "DeepInfo",
  components:{
    Navigation
  },
  methods:{
    changeView(routeName){
      this.$router.push({name: routeName});
    }
  },
  mounted(){
    Event.$emit('playAudio', 'DeepInfo');
  }
}
</script>

<style lang="css" scoped>
.blissing-logo{
  width: 20rem;
}

.circles{
  width: 13rem;
  height: 13rem;
}

@media (min-width: 1024px){

  .circles{
    width: 13rem;
    height: 13rem;
  }

}

@media (min-width: 1280px){

  .circles{
    width: 15rem;
    height: 15rem;
  }

}

@media (min-width: 1367px){

  .circles{
    width: 18rem;
    height: 18rem;
  }

}

@media (min-width: 2000px){

  .circles{
    width: 24rem;
    height: 24rem;
  }

}

</style>
